import { Controller } from "@hotwired/stimulus";
import paymentMiddlewareUrlService from "../../service/payment/payment_middleware_url_service";
import { Modal } from "bootstrap";
import WebViewEventService from "../../../services/WebViewEventService";
import GtagService from "../../../services/GtagService";

export default class extends Controller {
  static values = {
    currency: String,
    coupon: String,
    quantityOrder: String,
    subscriptionType: String,
    krwAmount: Number,
    planName: String,
    cardAction: String,
    directCard: Boolean,
  };

  paymentTypeModal = Modal.getOrCreateInstance(
    document.getElementById("choosePaymentMethod"),
  );

  async connect() {
    const modal = this.paymentTypeModal._element;
    if (modal) {
      modal.addEventListener("show.bs.modal", (event) => {
        this.showModalOrRedirectToCard(event);
      });
      modal.addEventListener("hidden.bs.modal", () => {
        this.clearActions(modal);
      });
    }

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        document.querySelectorAll(".payment-redirecting").forEach((btn) => {
          btn.classList.remove("disabled", "payment-redirecting");
          btn.removeAttribute("aria-disabled");
        });
      }
    });
  }

  showModalOrRedirectToCard(event) {
    if (this.showConfirmed) {
      this.showConfirmed = false;
      return;
    }

    event.preventDefault();
    const pricingBtn = event.relatedTarget;
    setTimeout(() => {
      if (this.directCardValue && typeof this[this.cardActionValue] === "function") {
        this.redirectToCard(pricingBtn);
        return;
      }

      this.showConfirmed = true;
      this.paymentTypeModal.show(pricingBtn);
    });
  }

  redirectToCard(pricingBtn) {
    if (pricingBtn) {
      pricingBtn.classList.add("disabled", "payment-redirecting");
      pricingBtn.setAttribute("aria-disabled", "true");
    }
    this[this.cardActionValue]();
  }

  closeModal() {
    this.paymentTypeModal.hide();
  }

  clearActions(modal) {
    const creditCardBtn = modal.querySelector(".btn-credit-card");
    const paypalBtn = modal.querySelector(".btn-paypal");
    const upiBtn = modal.querySelector(".btn-upi");

    if (creditCardBtn) creditCardBtn.setAttribute("data-action", "");
    if (paypalBtn) paypalBtn.setAttribute("data-action", "");
    if (upiBtn) upiBtn.setAttribute("data-action", "");
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-card-action-value",
      "",
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-direct-card-value",
      "false",
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-currency-value",
      "",
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-coupon-value",
      "",
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-quantity-order-value",
      "",
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-subscription-type-value",
      "",
    );
    modal.removeAttribute(
      "data-payment--choose-payment-method-modal-krw-amount-value",
    );
    modal.setAttribute(
      "data-payment--choose-payment-method-modal-plan-name-value",
      "",
    );
  }

  checkoutLiteYearPaypal() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "year",
    });
  }

  checkoutLiteYearCard() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "year",
    });
  }

  checkoutLiteMonthPaypal() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "month",
    });
  }

  checkoutLiteMonthCard() {
    this.checkoutLiteService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "month",
    });
  }

  checkoutPremiumYearPaypal() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "year",
    });
  }

  checkoutPremiumYearCard() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "year",
    });
  }

  checkoutPremiumMonthPaypal() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      period: "month",
    });
  }

  checkoutPremiumMonthCard() {
    this.checkoutPremiumService({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      period: "month",
    });
  }

  sendYahooSubscribeConversion() {
    const isMeLink = document.body.dataset.appBrand === "me-short-link";

    window?.ytag &&
      ytag({
        type: "yss_conversion",
        config: {
          yahoo_conversion_id: "1001407004",
          yahoo_conversion_label: isMeLink ? "-eSsCPKzooEdEPTnqqhE" : "eD0RCPv54t8cEPTnqqhE",
          yahoo_conversion_value: isMeLink ? "1" : "0",
        },
      });
  }

  sendNaverPurchaseConversion() {
    if (!window.wcs || !window.naverAccountId) return;

    const quantity = parseInt(this.quantityOrderValue, 10) || 1;
    if (!this.hasKrwAmountValue || !(this.krwAmountValue > 0) || quantity !== 1) return;

    const amount = Number(this.krwAmountValue.toFixed(2));
    window.wcs_add = window.wcs_add || {};
    window.wcs_add["wa"] = window.naverAccountId;
    window.wcs.trans({
      type: "purchase",
      id: `${this.subscriptionTypeValue}_${Date.now()}`,
      items: [
        {
          id: this.subscriptionTypeValue,
          name: this.planNameValue.replace(/["']/g, ""),
          category: "subscription",
          quantity: 1,
          payAmount: amount,
        },
      ],
      value: String(amount),
    });
  }

  checkoutLiteService({ serviceName, period }) {
    this.sendYahooSubscribeConversion();
    PaymentMainController.trackLinkedInConversion();
    WebViewEventService.subscriptionLite();
    if (period === "month") {
      window.location.href =
        paymentMiddlewareUrlService.getLiteMonthMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    } else if (period === "year") {
      window.location.href =
        paymentMiddlewareUrlService.getLiteYearMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    }
    this.paymentTypeModal.hide();
  }

  checkoutPremiumService({ serviceName, period }) {
    this.sendYahooSubscribeConversion();
    PaymentMainController.trackLinkedInConversion();
    WebViewEventService.subscriptionPremium();
    if (period === "month") {
      window.location.href =
        paymentMiddlewareUrlService.getPremiumMonthMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    } else if (period === "year") {
      window.location.href =
        paymentMiddlewareUrlService.getPremiumYearMiddlewareUrl({
          currency: this.currencyValue,
          coupon: this.couponValue,
          serviceName,
        });
    }
    this.paymentTypeModal.hide();
  }

  checkoutLiteMultisubCard() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      type: "lite",
    });
  }

  checkoutLiteMultisubPaypal() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      type: "lite",
    });
  }

  checkoutPremiumMultisubCard() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.card,
      type: "premium",
    });
  }

  checkoutPremiumMultisubPaypal() {
    this.checkoutMultisub({
      serviceName: paymentMiddlewareUrlService.paymentTypes.paypal,
      type: "premium",
    });
  }

  checkoutBarcodeCard() {
    this.checkoutBarcode(paymentMiddlewareUrlService.paymentTypes.card);
  }

  checkoutBarcodePaypal() {
    this.checkoutBarcode(paymentMiddlewareUrlService.paymentTypes.paypal);
  }

  checkoutBarcode(serviceName) {
    window.location.href = paymentMiddlewareUrlService.getBarcodeMiddlewareUrl({
      subscriptionType: this.subscriptionTypeValue,
      currency: this.currencyValue,
      serviceName,
    });
  }

  checkoutMultisub({ serviceName, type }) {
    this.sendYahooSubscribeConversion();
    this.sendNaverPurchaseConversion();
    const targetUrl =
      type === "premium"
        ? paymentMiddlewareUrlService.getPremiumMiddlewareUrl({
            subscriptionType: this.subscriptionTypeValue,
            currency: this.currencyValue,
            quantityOrder: this.quantityOrderValue,
            coupon: this.couponValue,
            serviceName,
          })
        : paymentMiddlewareUrlService.getLiteMiddlewareUrl({
            subscriptionType: this.subscriptionTypeValue,
            currency: this.currencyValue,
            quantityOrder: this.quantityOrderValue,
            coupon: this.couponValue,
            serviceName,
          });


    const event = this.meLinkPaymentEvent(serviceName);
    if (event) {
      GtagService.gtagEventAndNavigate({ event, targetUrl });
      return;
    }

    window.location.href = targetUrl;
  }


  meLinkPaymentEvent(serviceName) {
    if (document.body.dataset.appBrand !== "me-short-link") {
      return null;
    }

    const isYearly = this.subscriptionTypeValue.endsWith("_year");
    const isCard = serviceName === paymentMiddlewareUrlService.paymentTypes.card;
    const event = isYearly
      ? (isCard ? "yearly_pay_card" : "yearly_pay_paypal")
      : (isCard ? "monthly_pay_card" : "monthly_pay_paypal");

    const storageKey = `gtag_once_${event}`;
    if (sessionStorage.getItem(storageKey) === "1") {
      return null;
    }
    sessionStorage.setItem(storageKey, "1");

    return event;
  }
}
